import React from 'react'
import './style.scss'
import LoginBtn from '../../components/buttons/loginBtn'

const FormLayout = ({ description, heading, children, onClick, disabled, label, btnLoading, showBack, onBack, removeHeader, backBtnText, whiteBg }) => {
    return (
        <div className='disclaimer__section'>
            {removeHeader ? "" : <>
                <div className='disclaimer__header'>
                    <h3>
                        {heading}
                    </h3>
                    <p>
                        {description}
                    </p>
                </div>
                {whiteBg ? "" : <div className='section__saperator' />}
            </>}
            <div className={`disclaimer__body ${whiteBg ? 'white__bg' : ''}`}>
                {children}
            </div>
            {showBack ? <div className='disclaimer__footer d-flex'>
                <LoginBtn whiteBtn loading={btnLoading} onClick={onBack} text={backBtnText ?? "Back"} />
                <LoginBtn loading={btnLoading} onClick={onClick} disabled={disabled} text={label ? label : "Next"} />
            </div> :
                <div className='disclaimer__footer'>
                    <div className='next__btn__section mt-0'>
                        <button loading={btnLoading} onClick={onClick} disabled={disabled}>
                            {label ? label : "Next"}
                        </button>
                    </div>
                </div>
            }
        </div>
    )
}

export default FormLayout